import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyAD7apxi9dWbCHWNWK_qTVB21_VIHVPLQw",
    authDomain: "whatsapp-mmis.firebaseapp.com",
    projectId: "whatsapp-mmis",
    storageBucket: "whatsapp-mmis.appspot.com",
    messagingSenderId: "44240021055",
    appId: "1:44240021055:web:ac24f75dcaae0b7f517a8a"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
